"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BottomMenuSheetRenderer_1 = __importDefault(require("../ControlRenderer/components/BottomMenuSheetRenderer"));
const ButtonRenderer_1 = __importDefault(require("../ControlRenderer/components/ButtonRenderer"));
const CalendarRenderer_1 = __importDefault(require("../ControlRenderer/components/CalendarRenderer"));
const CameraViewRenderer_1 = __importDefault(require("../ControlRenderer/components/CameraViewRenderer"));
const ContainerRenderer_1 = __importDefault(require("../ControlRenderer/components/ContainerRenderer"));
const FlatListRenderer_1 = __importDefault(require("../ControlRenderer/components/FlatListRenderer"));
const GraphicRender_1 = __importDefault(require("../ControlRenderer/components/GraphicRender"));
const IconRenderer_1 = __importDefault(require("../ControlRenderer/components/IconRenderer"));
const ImageRenderer_1 = __importDefault(require("../ControlRenderer/components/ImageRenderer"));
const MapRenderer_1 = __importDefault(require("../ControlRenderer/components/MapRenderer"));
const PageRenderer_1 = __importDefault(require("../ControlRenderer/components/PageRenderer"));
const PickerRenderer_1 = __importDefault(require("../ControlRenderer/components/PickerRenderer"));
const SectionListRenderer_1 = __importDefault(require("../ControlRenderer/components/SectionListRenderer"));
const SideMenuRenderer_1 = __importDefault(require("../ControlRenderer/components/SideMenuRenderer"));
const SwiperRender_1 = __importDefault(require("../ControlRenderer/components/SwiperRender"));
const SwitchRenderer_1 = __importDefault(require("../ControlRenderer/components/SwitchRenderer"));
const RadioButtonRender_1 = __importDefault(require("../ControlRenderer/components/RadioButtonRender"));
const TextAreaRenderer_1 = __importDefault(require("../ControlRenderer/components/TextAreaRenderer"));
const TextInputRenderer_1 = __importDefault(require("../ControlRenderer/components/TextInputRenderer"));
const VideoViewRender_1 = __importDefault(require("../ControlRenderer/components/VideoViewRender"));
const WebViewRenderer_1 = __importDefault(require("../ControlRenderer/components/WebViewRenderer"));
const SliderRenderer_1 = __importDefault(require("../ControlRenderer/components/SliderRenderer"));
const DatePickerRender_1 = __importDefault(require("../ControlRenderer/components/DatePickerRender"));
const CheckboxRenderer_1 = __importDefault(require("../ControlRenderer/components/CheckboxRenderer"));
const VideoRenderer_1 = __importDefault(require("../ControlRenderer/components/VideoRenderer"));
const BannerAdRenderer_1 = __importDefault(require("../ControlRenderer/components/BannerAdRenderer"));
const controlBuildRenderFunction = (control, parent) => () => {
    switch (control.tag) {
        case 'page':
            return react_1.default.createElement(PageRenderer_1.default, { page: control });
        case 'View':
            return react_1.default.createElement(ContainerRenderer_1.default, { container: control, parent: parent });
        case 'text':
            return react_1.default.createElement(TextAreaRenderer_1.default, { textControl: control });
        case 'button':
            return react_1.default.createElement(ButtonRenderer_1.default, { button: control });
        case 'image':
            return react_1.default.createElement(ImageRenderer_1.default, { image: control });
        case 'map':
            return react_1.default.createElement(MapRenderer_1.default, { map: control });
        case 'icon':
            return react_1.default.createElement(IconRenderer_1.default, { icon: control });
        case 'ionitem':
            return react_1.default.createElement(TextInputRenderer_1.default, { inputControl: control });
        case 'switch':
            return react_1.default.createElement(SwitchRenderer_1.default, { switchControl: control });
        case 'camera':
            return react_1.default.createElement(CameraViewRenderer_1.default, { cameraControl: control });
        case 'webView':
            return react_1.default.createElement(WebViewRenderer_1.default, { webViewControl: control });
        case 'Picker':
            return react_1.default.createElement(PickerRenderer_1.default, { pickerControl: control });
        case 'flatList':
            return react_1.default.createElement(FlatListRenderer_1.default, { flatListControl: control, parent: parent });
        case 'sectionList':
            return react_1.default.createElement(SectionListRenderer_1.default, { listControl: control, parent: parent });
        case 'sideMenu':
            return react_1.default.createElement(SideMenuRenderer_1.default, { sideMenu: control });
        case 'bottomMenuSheet':
            return react_1.default.createElement(BottomMenuSheetRenderer_1.default, { control: control });
        case 'videoView':
            return react_1.default.createElement(VideoViewRender_1.default, { videoControl: control });
        case 'Swiper':
            return react_1.default.createElement(SwiperRender_1.default, { swiperControl: control });
        case 'calendar':
            return react_1.default.createElement(CalendarRenderer_1.default, { calendarControl: control });
        case 'graphicView':
            return react_1.default.createElement(GraphicRender_1.default, { graphicControl: control });
        case 'radio':
            return react_1.default.createElement(RadioButtonRender_1.default, { radioControl: control });
        case 'slider':
            return react_1.default.createElement(SliderRenderer_1.default, { slider: control });
        case 'datePicker':
            return react_1.default.createElement(DatePickerRender_1.default, { dateControl: control });
        case 'topNavBar':
            return react_1.default.createElement(ContainerRenderer_1.default, { container: control, parent: parent });
        case 'checkbox':
            return react_1.default.createElement(CheckboxRenderer_1.default, { checkbox: control });
        case 'video':
            return react_1.default.createElement(VideoRenderer_1.default, { videoControl: control });
        case 'bannerAd':
            return react_1.default.createElement(BannerAdRenderer_1.default, { bannerControl: control });
        default:
            return null;
    }
};
exports.default = controlBuildRenderFunction;
